import React, { useContext } from "react"
import styled from "styled-components"
import { mediaQuery } from "@zendeskgarden/react-theming"
import { Ellipsis } from "@zendeskgarden/react-typography"
import { Link } from "gatsby"
import { Breadcrumb } from "@zendeskgarden/react-breadcrumbs"
import { searchResult } from "../../lib/prop-types"
import SearchModalContext from "./searchModalContext"

const StyledLink = styled(Link)`
  display: block;
  padding: ${props => `${props.theme.space.md} ${props.theme.space.lg}`};

  ${props => mediaQuery("down", "sm", props.theme)} {
    padding: ${props => `${props.theme.space.md} ${props.theme.space.horz.md}`};
  }

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    background-color: ${props => props.theme.colors.search.resultHover};
  }
`

const Title = styled.div`
  margin-bottom: ${props => props.theme.space.xxs};
  color: ${props => props.theme.colors.document.links};
  font-size: ${props => props.theme.fontSizes.md};

  em {
    font-weight: ${props => props.theme.fontWeights.bold};
  }
`

const ArticleTextPreview = styled.div`
  margin-bottom: ${props => props.theme.space.xs};
  color: ${props => props.theme.colors.document.headingsSecondary};
  font-size: ${props => props.theme.fontSizes.sm};

  em {
    font-weight: ${props => props.theme.fontWeights.bold};
  }
`

const StyledBreadcrumb = styled(Breadcrumb)`
  svg path {
    color: ${props => props.theme.colors.sidebar.breadcrumbs};
  }
`

const Crumb = styled.div`
  color: ${props => props.theme.colors.document.subheading};
  font-size: ${props => props.theme.fontSizes.sm};
`

const SearchResult = props => {
  const { title, highlightedTitle, articlePlainText, slug, breadcrumbs } = props
  const { setViewedResults, setOpenSearchModal } =
    useContext(SearchModalContext)
  const currentPage = window.location.pathname

  return (
    <StyledLink
      to={slug}
      onClick={() => {
        setViewedResults({ title, slug, breadcrumbs })
        if (slug === currentPage) {
          setOpenSearchModal(false)
        }
      }}
    >
      <Title>
        <Ellipsis
          dangerouslySetInnerHTML={{ __html: highlightedTitle || title }}
        />
      </Title>
      {articlePlainText && (
        <ArticleTextPreview>
          <Ellipsis dangerouslySetInnerHTML={{ __html: articlePlainText }} />
        </ArticleTextPreview>
      )}
      <StyledBreadcrumb>
        {breadcrumbs &&
          breadcrumbs.map(crumb => <Crumb key={crumb}>{crumb}</Crumb>)}
      </StyledBreadcrumb>
    </StyledLink>
  )
}

SearchResult.propTypes = {
  ...searchResult
}

export default SearchResult
